import { makeStyles } from '@material-ui/core/styles'

import themesConfig from 'app/fuse-configs/themesConfig'

import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  deleteDialog: {
    '& .MuiPaper-root': {
      padding: '20px 40px',
      maxWidth: 374,
      [useBreakpoints(theme).lessThan.sm]: {
        padding: 15,
      },
    },
  },

  deleteDialogTitle: {
    marginBottom: 10,
    padding: 0,
    textAlign: 'center',
  },

  deleteDialogContent: {
    marginBottom: 42,
    padding: 0,
    textAlign: 'center',
    fontSize: 14,
  },

  deleteDialogActions: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
  },
  cancelBtn: {
    borderColor: themesConfig.default.palette.primary.subtitle,
    '&:hover': {
      borderColor: themesConfig.default.palette.primary.subtitle,
    },
  },
}))
